import axios from "axios"
import { SERVER_URI } from "../utils/config"
import { checkToken } from "./checkToken"

export const dbselect = async (table, id) => {
	checkToken()
	try{
		const response = await axios.get(`${SERVER_URI}/${table}/${id}`)
		return response.data
	} catch (err) {
		console.error(err)
		throw new Error("Error selecting data")
	}
}

export const reducerInit = (table, ordercol) => {
	const data = []
	let params = ""
	if (table === "servicequestion") {
		params += "order?orderby=sqorder"
	} else if (table === "service") {
		params += "order?orderby=serviceorder"
	} else if (table === "phase") {
		params += "order?orderby=phaseorder"
	}
	dbselect(table, params).then((selectdata) => {
		for (const obj of selectdata) {
			data.push(obj)
		}
		if (ordercol) {
			return data.sort((a, b) => (Number(a[ordercol]) > Number(b[ordercol]) ? 1 : -1))
		} else {
			return data
		}
	})

	return data
}
